import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { downloadFile, reportLinks } from '../lib/api'
import { useFindings } from '../lib/queries'
import { PageHead, Severity, Skel, Empty, Money, RiskBar } from '../components/ui'
import { thaiDate } from '../lib/format'

export function Findings() {
  const [severity, setSeverity] = useState('')
  const [status, setStatus] = useState('')
  const navigate = useNavigate()
  const q = useFindings({ severity, status, limit: '100' })
  const rows = q.data ?? []

  return (
    <>
      <PageHead title="ข้อสังเกต" sub={`${rows.length} รายการ · ทุกข้อสังเกตอ้างอิงหลักฐานและสูตรคำนวณ`}
        actions={<div className="row" style={{ gap: 8 }}>
          <button className="btn" onClick={async () => {
            const l = await reportLinks()
            window.open(l.pdf_url, '_blank', 'noopener')
          }}>รายงาน PDF</button>
          <button className="btn" onClick={async () => {
            const l = await reportLinks()
            window.open(l.xlsx_url, '_blank', 'noopener')
          }}>Excel</button>
          <button className="btn btn-ghost" onClick={() => void downloadFile('/v1/reports/findings.csv', 'auditai-findings.csv')}>CSV</button>
        </div>} />
      <div className="filters">
        <select className="select" value={severity} onChange={(e) => setSeverity(e.target.value)} aria-label="กรองตามระดับ">
          <option value="">ทุกระดับ</option>
          <option value="critical">วิกฤต</option>
          <option value="high">สูง</option>
          <option value="medium">ปานกลาง</option>
          <option value="low">ต่ำ</option>
        </select>
        <select className="select" value={status} onChange={(e) => setStatus(e.target.value)} aria-label="กรองตามสถานะ">
          <option value="">ทุกสถานะ</option>
          <option value="open">เปิด</option>
          <option value="investigating">กำลังสอบ</option>
          <option value="pending_review">รอทวนสอบ</option>
          <option value="approved">อนุมัติแล้ว</option>
        </select>
        <div className="dim" style={{ marginLeft: 'auto', fontSize: 11.5 }}>เรียงตามคะแนนความเสี่ยง</div>
      </div>

      {q.isLoading ? (
        <div className="stack"><Skel h={52} /><Skel h={52} /><Skel h={52} /><Skel h={52} /></div>
      ) : rows.length === 0 ? (
        <div className="card"><Empty title="ไม่พบข้อสังเกตตามเงื่อนไข" body="ลองล้างตัวกรอง หรือรันการตรวจสอบใหม่" /></div>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>ข้อสังเกต</th><th>กฎ</th><th>ระดับ</th><th style={{ width: 128 }}>คะแนน</th>
                <th style={{ textAlign: 'right' }}>มูลค่าเสี่ยง</th><th>สถานะ</th><th>วันที่</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((f) => (
                <tr key={f.id} onClick={() => navigate(`/findings/${f.id}`)}>
                  <td>
                    <Link to={`/findings/${f.id}`} style={{ color: 'var(--color-ivory)' }}>{f.title}</Link>
                    <div className="dim" style={{ fontSize: 11, marginTop: 3 }}>{f.summary}</div>
                  </td>
                  <td className="mono dim">{f.rule_code}</td>
                  <td><Severity value={f.severity} /></td>
                  <td><RiskBar score={f.risk_score} /></td>
                  <td className="num"><Money satang={f.amount_at_risk_satang} compact /></td>
                  <td><span className={`chip${f.status === 'approved' ? ' gold' : ''}`}>{statusLabel(f.status)}</span></td>
                  <td className="dim">{thaiDate(f.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export function statusLabel(s: string): string {
  const m: Record<string, string> = {
    open: 'เปิด', triaged: 'คัดกรอง', investigating: 'กำลังสอบ', pending_review: 'รอทวนสอบ',
    approved: 'อนุมัติ', rejected: 'ตีกลับ', false_positive: 'ไม่ใช่ความเสี่ยง', closed: 'ปิด',
  }
  return m[s] ?? s
}
